import { useIntersection } from "react-use"
import { RefObject } from "react"

export function useCustomIntersection<T>(ref: RefObject<T & HTMLElement>, option: IntersectionObserverInit) {
  const isInterSection = useIntersection(ref, option)
  return { isInterSection }
}